import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

export const LocationOutlineIcon = (props: SVGProps): JSX.Element => {
  return <SpriteIcon spriteId="marker-pin" {...props} />;
};
